import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1529c81d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "nav-container" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 7,
  id: "view-profile-button"
}
const _hoisted_4 = { id: "small" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Register", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Login", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "link-gap" }, null, -1))
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 7,
  class: "navtab-button",
  id: "avatar-button"
}
const _hoisted_10 = { id: "small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Brand = _resolveComponent("Brand")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_nav_tab = _resolveComponent("nav-tab")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Dashboard = _resolveComponent("Dashboard")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("nav", {
    class: _normalizeClass({ mobile: _ctx.store.state.isMobile })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Brand, { "is-center": false }),
      (_ctx.store.state.isMobile && _ctx.store.state.isAuthenticated)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            id: "hamburger",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
            class: _normalizeClass({ open: _ctx.opened })
          }, [
            _createVNode(_component_Menu, { "font-size": "32px" })
          ], 2))
        : _createCommentVNode("", true),
      (!['login','register','verify-email', 'forget-password'].includes(_ctx.$route.name) && !_ctx.store.state.isMobile)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            id: "link-container",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
          }, [
            (_ctx.isAdmin)
              ? (_openBlock(), _createBlock(_component_nav_tab, {
                  key: 0,
                  to: "/artists-list"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Artists List")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.isAdmin)
              ? (_openBlock(), _createBlock(_component_nav_tab, {
                  key: 1,
                  to: "/artists-registration"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Artists Registration")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_ctx.isAdmin)
              ? (_openBlock(), _createBlock(_component_nav_tab, {
                  key: 2,
                  to: "/profil"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Your Profile")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_ctx.isAdmin)
              ? (_openBlock(), _createBlock(_component_nav_tab, {
                  key: 3,
                  to: "/portfolio"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Portfolio")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_ctx.isAdmin)
              ? (_openBlock(), _createBlock(_component_nav_tab, {
                  key: 4,
                  to: "/service"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Service")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_ctx.isAdmin)
              ? (_openBlock(), _createBlock(_component_nav_tab, {
                  key: 5,
                  to: "/schedule"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Schedule")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_ctx.isAdmin)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 6,
                  id: "view-profile-button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openProfile && _ctx.openProfile(...args))),
                  disabled: !_ctx.isArtistActive
                }, " View profile page ", 8, _hoisted_2))
              : _createCommentVNode("", true),
            (_ctx.store.state.isMobile)
              ? (_openBlock(), _createElementBlock("button", _hoisted_3, [
                  _createElementVNode("div", {
                    class: "photo",
                    style: _normalizeStyle({'background-image': 'url('+ (_ctx.store.state.photoUrl || '@/assets/img/brand.png') +')'})
                  }, null, 4),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.store.state.email), 1),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.isAdmin ? "ADMIN" : "ARTIST"), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.store.state.isMobile)
              ? (_openBlock(), _createBlock(_component_nav_tab, {
                  key: 8,
                  onTestClick: _ctx.logout,
                  to: "/"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Log out")
                  ]),
                  _: 1
                }, 8, ["onTestClick"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      ('login'.includes(_ctx.$route.name) && !_ctx.store.state.isMobile)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: "/register"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_button, {
                id: "registerBtn",
                type: "primary",
                size: "medium"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      ('register'.includes(_ctx.$route.name) && !_ctx.store.state.isMobile)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 3,
            to: "/login"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_button, {
                id: "loginBtn",
                type: "primary",
                size: "medium"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!['login','register'].includes(_ctx.$route.name))
        ? (_openBlock(), _createBlock(_component_Dashboard, { key: 4 }))
        : _createCommentVNode("", true)
    ]),
    (!['login','register'].includes(_ctx.$route.name) && _ctx.store.state.isMobile)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "link-container",
          class: _normalizeClass({ mobile: _ctx.store.state.isMobile, open: _ctx.opened }),
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
        }, [
          _hoisted_7,
          (_ctx.isAdmin)
            ? (_openBlock(), _createBlock(_component_nav_tab, {
                key: 0,
                to: "/artists-list"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Artists List")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isAdmin)
            ? (_openBlock(), _createBlock(_component_nav_tab, {
                key: 1,
                to: "/artists-registration"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Artists Registration")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isAdmin)
            ? (_openBlock(), _createBlock(_component_nav_tab, {
                key: 2,
                to: "/profil"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Your Profile")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isAdmin)
            ? (_openBlock(), _createBlock(_component_nav_tab, {
                key: 3,
                to: "/portfolio"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Portfolio")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isAdmin)
            ? (_openBlock(), _createBlock(_component_nav_tab, {
                key: 4,
                to: "/service"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Service")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!_ctx.isAdmin)
            ? (_openBlock(), _createBlock(_component_nav_tab, {
                key: 5,
                to: "/schedule"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Schedule")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.store.state.isMobile)
            ? (_openBlock(), _createElementBlock("button", {
                key: 6,
                class: "navtab-button",
                id: "view-profile-button-mobile",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openProfile && _ctx.openProfile(...args))),
                disabled: !_ctx.isArtistActive
              }, " View Profile ", 8, _hoisted_8))
            : _createCommentVNode("", true),
          (_ctx.store.state.isMobile)
            ? (_openBlock(), _createElementBlock("button", _hoisted_9, [
                _createElementVNode("div", {
                  class: "photo",
                  style: _normalizeStyle({'background-image': 'url('+ (_ctx.store.state.photoUrl || '@/assets/img/brand.png') +')'})
                }, null, 4),
                _createElementVNode("div", null, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.store.state.email), 1),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.isAdmin ? "ADMIN" : "ARTIST"), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.store.state.isMobile)
            ? (_openBlock(), _createBlock(_component_nav_tab, {
                key: 8,
                onTestClick: _ctx.logout,
                to: "/"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Log out")
                ]),
                _: 1
              }, 8, ["onTestClick"]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ], 2)), [
    [_directive_click_outside, _ctx.hide]
  ])
}